import { createContext } from 'react';

/** POS opts in at its root; shared screens in other apps remain unchanged. */
export const BlockingExitContext = createContext<{
  enabled: boolean;
  blocked: boolean;
  operatorVerification: boolean;
  request: () => void;
}>({ enabled: false, blocked: false, operatorVerification: false, request: () => undefined });
